const baseURL = process.env.REACT_APP_NIPPON_CONVOZE_BASE_API_URL;

const apiEndPointsConfig = {
  addLogin: `${baseURL}/manager-panel/login`,
  register: `${baseURL}/manager-panel/add-user`,
  upload: `${baseURL}/manager-panel/call-recording/upload`,
  checkDuplicateFileNames: `${baseURL}/manager-panel/call-recording/check-duplicates`,
  publicUpload: `${baseURL}/manager-panel/call-recording/public-upload`,
  demoUploadFile: `${baseURL}/manager-panel/call-recording/demo-upload`,
  audioTable: `${baseURL}/manager-panel/call-recording/list`,
  transcript: `${baseURL}/manager-panel/transcription/audio-insight`,
  dashboard: `${baseURL}/manager-panel/dashboard/insights`,
  kiwiDashboard: `${baseURL}/kiwi/dashboard/insights`,
  interactionTrendAnalytics: `${baseURL}/manager-panel/interactions/last-month-trends`,
  agentCompetencyImprovement: `${baseURL}/manager-panel/interactions/agent-competency-improvement`,
  kiwiInteractionTrendAnalytics: `${baseURL}/kiwi/interactions/last-month-trends`,
  agentReportInsights: `${baseURL}/manager-panel/interactions/agent-report-insights`,
  industryType: `${baseURL}/manager-panel/industry-type/list`,
  demoTranscript: `${baseURL}/audio-insight`,
  interaction: `${baseURL}/manager-panel/interactions/list`,
  interactionList: `${baseURL}/manager-panel/interactions`,
  kiwiInteraction: `${baseURL}/kiwi/interactions/list`,
  callRecordingList: `${baseURL}/manager-panel/call-recording/interaction-list`,
  kiwiInteractionList: `${baseURL}/kiwi/interactions`,
  kiwiFilterDetails: `${baseURL}/kiwi/interactions/filter-details`,
  kiwiCallRecordingList: `${baseURL}/kiwi/call-recording/interaction-list`,
  kiwiStreamAudio: `${baseURL}/kiwi/call-recording/stream`,
  toggleCuration: `${baseURL}/manager-panel/call-recording/toggle-curation`,
  reprocessCallRecording: `${baseURL}/manager-panel/call-recording/reprocess`,
  qaParameters: `${baseURL}/manager-panel/qa-audit`,
  agentCampaignList: `${baseURL}/manager-panel/interactions/filter-details`,
  userProfile: `${baseURL}/manager-panel/profile-details`,
  agentList: `${baseURL}/manager-panel/agent-list`,
  changePassword: `${baseURL}/manager-panel/change-password`,
  billing: `${baseURL}/manager-panel/billing-invoice`,
  agentProfile: `${baseURL}/manager-panel/agent-profile `,
  exportExcelInteraction: `${baseURL}/manager-panel/interactions/excel-interaction`,
  chatbotApi: `${baseURL}/chatbot/chatbot-query`,
  companyList: `${baseURL}/super-admin-panel/companies`,
  ReprocessQaparameter: `${baseURL}/manager-panel/reprocess-qa-audit`,
  ReprocessInteractionInsight: `${baseURL}'/manager-panel/reprocess-interaction'`,
  updateQaParameters: `${baseURL}/manager-panel/update-qa-parameters`,
  updateMultipleQaParameters: `${baseURL}/manager-panel/update-multiple-qa-parameters`,
  kiwiElevenLabsList: `${baseURL}/manager-panel/kiwi-elevenlabs/list`,
  kiwiElevenLabsSync: `${baseURL}/manager-panel/kiwi-elevenlabs/sync`,
  kiwiElevenLabsProcess: `${baseURL}/manager-panel/kiwi-elevenlabs/process`,
  kiwiElevenLabsPlay: `${baseURL}/manager-panel/kiwi-elevenlabs/play`,
  kiwiCuratorDownload: `${baseURL}/manager-panel/kiwi-elevenlabs/curator/download`,

  // super admin
  defaultListOfQAparameter: `${baseURL}/convoze-default-prompt`,
  invoiceGeneration: `${baseURL}/super-admin/billing-invoice`,
  downloadInvoice: `${baseURL}/super-admin/download-invoice`,
  clientOnboarding: `${baseURL}/super-admin-panel/client-management`,
  clientList: `${baseURL}/super-admin-panel/client-list`,
  updateCompanyData: `${baseURL}/super-admin-panel/update-client-data`,
  clinetPromptData: `${baseURL}/super-admin-panel/client-prompt-data`,
  updateClientPrompt: `${baseURL}/super-admin-panel/update-client-prompt`,
  processList: `${baseURL}/super-admin-panel/process-list`,
  processPromptData: `${baseURL}/super-admin-panel/process-prompt-data`,

  // agent
  agentMyCalls: `${baseURL}/agent-panel/call-analytics`,
  agentDashboard: `${baseURL}/agent-panel/dashboard/insights`,
  agentLeaderboard: `${baseURL}/agent-panel/leaderboard`,
  agentKpis: `${baseURL}/agent-panel/kpis-analytics`,

  // user management
  createUser: `${baseURL}/manager-panel/users-add`,
  updateUser: `${baseURL}/manager-panel/update-user`,
  getUsers: `${baseURL}/manager-panel/user-management`,
  deleteUser: `${baseURL}/manager-panel/delete-user`,
  userRoles: `${baseURL}/manager-panel/user-roles`,
  streamAudio: `${baseURL}/manager-panel/call-recording/stream`,
  assignBranchManagers: `${baseURL}/manager-panel/assign-branch-managers`,
  getAssignedBranchManagers: `${baseURL}/manager-panel/assigned-branch-managers`,
  uploadSop: `${baseURL}/sop-training/upload`,
  hrList: `${baseURL}/manager-panel/hr-list`
};

export default apiEndPointsConfig;
